import { Injectable } from '@angular/core';
import { ContextService } from '../context/context.service';
import { Role } from '../../models/role';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  constructor(private readonly contextService: ContextService) {}

  get currentUserRoles(): Role[] {
    return this.contextService.currentUserRoles as Role[];
  }
}
